import { useToastPosition } from '@/app/providers';
import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

interface CustomToasterProps extends Omit<ToasterProps, 'position'> {
  position?:
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-center'
    | 'bottom-right';
}

const Toaster = ({ position: propPosition, ...props }: CustomToasterProps) => {
  const { theme = 'system' } = useTheme();
  const { position: contextPosition } = useToastPosition();
  const position = propPosition || contextPosition;

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      position={position}
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
